export default __webpack_public_path__ + "33aa5676c1932be15d412a5aa90d8b48.png";